// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".5de4e0af1ad28ff147783113abe5600b054b88ad.chunk.js";
};